import { render } from "./CalendarPage.vue?vue&type=template&id=28505f1f&scoped=true"
import script from "./CalendarPage.vue?vue&type=script&lang=js"
export * from "./CalendarPage.vue?vue&type=script&lang=js"

import "./CalendarPage.vue?vue&type=style&index=0&id=28505f1f&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/standart-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28505f1f"]])

export default __exports__